import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { ADDRESS, MAPS_URL } from "../constants/siteContact";
import { FOOTER_SOCIAL_LINKS } from "../constants/socialLinks";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <Logo size="small" />
            <h3>PANTHI EVENTS</h3>
            <p>Your Event, Our Passion</p>
            <div className="social-links">
              {FOOTER_SOCIAL_LINKS.map(({ id, label, href, Icon }) => (
                <a
                  key={id}
                  href={href}
                  aria-label={label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/gallery">Gallery</Link>
              </li>
              <li>
                <Link to="/blogs">Blogs</Link>
              </li>
              <li>
                <Link to="/reviews">Reviews</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              {/* <li>
                <Link to="/event-management-ahmedabad">Ahmedabad — Events</Link>
              </li>
              <li>
                <Link to="/wedding-planner-ahmedabad">
                  Ahmedabad — Weddings
                </Link>
              </li> */}
            </ul>
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li>
                <Link to="/wedding-events">Wedding Planning</Link>
              </li>
              <li>
                <Link to="/birthday-events">Birthday Celebrations</Link>
              </li>
              <li>
                <Link to="/corporate-events">Corporate Events</Link>
              </li>
              <li>
                <Link to="/social-events">Anniversary Parties</Link>
              </li>
              <li>
                <Link to="/production">Event Decoration</Link>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul>
              <li className="footer-contact-row">
                <span className="footer-contact-icon" aria-hidden="true">
                  📞
                </span>
                <a href="tel:+919978822213">+91 99788 22213</a>
              </li>
              <li className="footer-contact-row footer-contact-email">
                <span className="footer-contact-icon" aria-hidden="true">
                  ✉️
                </span>
                <a href="mailto:admin.panthievent@gmail.com">
                  admin.panthievent@gmail.com
                </a>
              </li>
              <li className="footer-contact-row footer-contact-address">
                <a
                  href={MAPS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Open address in Google Maps"
                >
                  📍 {ADDRESS}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {new Date().getFullYear()} PANTHI EVENTS. All rights
            reserved.
          </p>
          <p className="footer-credit">
            Developed by{" "}
            <a
              href="https://siddhisolutions.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Siddhi Solutions
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
